import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({ providedIn: 'root' })
export class DraftAccessGuard implements CanActivate {
  constructor(private deviceService: DeviceDetectorService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let userId = null;
    try {
      const currentUserStr = localStorage.getItem('currentUser');
      if (currentUserStr) {
        const currentUser = JSON.parse(currentUserStr);
        userId = currentUser.id;
      }
    } catch (e) {
      console.error('Error parsing currentUser from localStorage', e);
    }

    const isDivisibleBy3 = userId && !isNaN(Number(userId)) && Number(userId) % 3 === 0;
    const isAndroidMobile = this.deviceService.isMobile() && this.deviceService.os === 'Android';
    if (!isAndroidMobile && !isDivisibleBy3) {
      const currentPath = state.url.startsWith('/') ? state.url : '/' + state.url;
      const redirectUrl = `${environment.SITE_URL}/draftsv2${currentPath}`; 
      window.location.href = redirectUrl;
      return false;
    }
    return true;
  }
}